import { useTranslation } from "react-i18next";

export const formatDate = (fecha, windowWidth, breakpoint) => {
  const [t, i18n] = useTranslation("global");

  const { language } = i18n;

  let fechas = fecha.split("/");

  let day = parseInt(fechas[0]);
  let month = parseInt(fechas[1]);
  let year = parseInt(fechas[2]);

  let date = `${year}/${month}/${day}`;

  const meses = ( windowWidth < breakpoint ) ? [
    t("MONTHS.months_abbr_list.1"),
    t("MONTHS.months_abbr_list.2"),
    t("MONTHS.months_abbr_list.3"),
    t("MONTHS.months_abbr_list.4"),
    t("MONTHS.months_abbr_list.5"),
    t("MONTHS.months_abbr_list.6"),
    t("MONTHS.months_abbr_list.7"),
    t("MONTHS.months_abbr_list.8"),
    t("MONTHS.months_abbr_list.9"),
    t("MONTHS.months_abbr_list.10"),
    t("MONTHS.months_abbr_list.11"),
    t("MONTHS.months_abbr_list.12"),
  ]
  :
  [
    t("MONTHS.months_list.1"),
    t("MONTHS.months_list.2"),
    t("MONTHS.months_list.3"),
    t("MONTHS.months_list.4"),
    t("MONTHS.months_list.5"),
    t("MONTHS.months_list.6"),
    t("MONTHS.months_list.7"),
    t("MONTHS.months_list.8"),
    t("MONTHS.months_list.9"),
    t("MONTHS.months_list.10"),
    t("MONTHS.months_list.11"),
    t("MONTHS.months_list.12"),
  ];


  const dias_semana = ( windowWidth < breakpoint ) ? [
    t("MONTHS.days_abbr_list.1"),
    t("MONTHS.days_abbr_list.2"),
    t("MONTHS.days_abbr_list.3"),
    t("MONTHS.days_abbr_list.4"),
    t("MONTHS.days_abbr_list.5"),
    t("MONTHS.days_abbr_list.6"),
    t("MONTHS.days_abbr_list.7"),
  ]
  :
  [
    t("MONTHS.days_list.1"),
    t("MONTHS.days_list.2"),
    t("MONTHS.days_list.3"),
    t("MONTHS.days_list.4"),
    t("MONTHS.days_list.5"),
    t("MONTHS.days_list.6"),
    t("MONTHS.days_list.7"),
  ]
  ;

  let ordinal;
  let string;
  let d = new Date(date);
  let dia = dias_semana[d.getDay()];

  if (language === "en") {
    if (dia === 1 || dia === 21 || dia === 31) {
      ordinal = "st";
    } else if (dia === 2 || dia === 22) {
      ordinal = "nd";
    } else if (dia === 3 || dia === 23) {
      ordinal = "rd";
    } else {
      ordinal = "th";
    }
    string = `${
      meses[d.getMonth()]
    }, ${dias_semana[d.getDay()]} ${d.getDate()}${ordinal}
    `;
    // string = `${dias_semana[d.getDay()]}, ${d.getDate()}${ordinal} of ${
    //   meses[d.getMonth()]
    // }`;
  } else {
    string = `${dias_semana[d.getDay()]}, ${d.getDate()} de ${
      meses[d.getMonth()]
    }`;
  }

  return string;
};
